import { IAward } from '../eventAwards/store';

export interface IUserAwards {
  [userId: number]: IAward[];
}
export interface IAdminRoundFormatAwardsStore {
  [roundId: number]: {
    [formatId: number]: IUserAwards;
  };
}

export const adminRoundFormatAwardsStore: IAdminRoundFormatAwardsStore = {};
